export enum dashboardTabs {
  home = "home",
  estimateDetails = "estimate",
  bookingDetail = "booking",
  bookingInspection = "booking-inspection",
  repairTracker = "repairTracker",
  estimateFeedback = "estimateFeedback",
  flowGetter = "flowGetter",
  referals = "referals",
  report = "report",
}